// extracted by mini-css-extract-plugin
export default {"acordeonTitle":"styles_acordeonTitle__l7Wmm","acordeonContent":"styles_acordeonContent__1Gv-T"};